<span class="steps-marker"></span>
<div class="steps-content">
  <p class="is-size-6">{{ step.text }}</p>
</div>
